export default __webpack_public_path__ + "images/8dd543d6d90e9415e126eca00fb44957-soccer.webp";